import React, {useContext, useEffect, useState} from "react";
import * as Constants from "./util/Constants";
import * as Helpers from "./util/Helpers";
import "./assets/styles.css";
import { useGlobalneVarijable } from "hooks/useGlobalneVarijable";
import tRoba from "./types/Roba";

const Roba = () => {
    const [data, setData] = useState<tRoba[]>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { grupaSifra, setGrupaSifra, robaSifra, setRobaSifra } = useGlobalneVarijable();


    useEffect(() => {
        fetch("https://rodendaonica.com/get_data.php",
            {
                method: "POST",
                headers:{
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(
                    {
                        Funkcija:"p_Grupa_Roba",
                        GrupaSifra:grupaSifra,
                        SvePodgrupe:1,

                    }),
            }
        )

            .then((response) => {
                if (!response.ok) {
                    //throw new Error(response.text.toString());
                    throw new Error("Greška pri dohvaćanju podataka");
                }
                return response.json();
            })
            .then((json) => {
                setData(json);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, [grupaSifra,setGrupaSifra]);


    if (loading) {
        return <p>Učitavanje:</p>;
    }

    if (error) {
        return <p style={{ color: "red" }}>{error}</p>;
    }


    return (

        <div className={"popis-roba"}>
            <div className={"roba-container"}>
            {data && data.map((item:tRoba) => (
                <div className={"roba"} key={"Roba"+item.RobaSifra}>Roba {item.RobaSifra}</div>
            ))}
            </div>
        </div>
    );

};


export default Roba;
